export default {
  NO_NARRATIVE_TYPES: "NO_NARRATIVE_TYPES",
  NO_EVENT_TYPES: "NO_EVENT_TYPES",
  EVENT_TYPE_PARENT: "EVENT_TYPE_PARENT",
  NO_NARRATIVE_LABEL: "NO_NARRATIVE_LABEL",
  NARRATIVE_LABEL_NO_AUTO_FOLDER: "NARRATIVE_LABEL_NO_AUTO_FOLDER",
  NARRATIVE_LABEL_NO_AUTO_OTHER: "NARRATIVE_LABEL_NO_AUTO_OTHER"
};

export const settingsErrorMessages = {
  NO_NARRATIVE_TYPES: "At least one item type must be allowed in narrative order.",
  NO_EVENT_TYPES: "There must be at least one Event type (item type allowed in chronological order).",
  EVENT_TYPE_PARENT: "Parents of Event Types must also be allowed in chronological order.",
  NO_NARRATIVE_LABEL: "There must be at least one narrative section type",
  NARRATIVE_LABEL_NO_AUTO_FOLDER: "At least one narrative section type must auto apply for folders",
  NARRATIVE_LABEL_NO_AUTO_OTHER: "At least one narrative section type must auto apply for other types"
};
